import { render, staticRenderFns } from "./PortfolioScreenMobile.vue?vue&type=template&id=2253a8d8&scoped=true"
import script from "./PortfolioScreenMobile.vue?vue&type=script&lang=js"
export * from "./PortfolioScreenMobile.vue?vue&type=script&lang=js"
import style0 from "./PortfolioScreenMobile.vue?vue&type=style&index=0&id=2253a8d8&prod&scoped=true&lang=css"
import style1 from "./PortfolioScreenMobile.vue?vue&type=style&index=1&id=2253a8d8&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2253a8d8",
  null
  
)

export default component.exports